module.exports = __webpack_public_path__ + "img/clock-blue.78e6534b.svg";